module.exports = __webpack_public_path__ + "img/right.d9ca4c27.svg";